const MAP_CHAT_MEMORY_KEY = 'strangers_map_chat_memory_v1';
const MAX_CHAT_MESSAGES = 30;

const normalizeRole = (role) => (role === 'assistant' ? 'assistant' : 'user');

const normalizeMessage = (message) => {
  if (!message || typeof message !== 'object') {
    return null;
  }

  const content = (message.content || '').toString().trim();
  if (!content) {
    return null;
  }

  return {
    id: (message.id || Date.now().toString(36)).toString(),
    role: normalizeRole(message.role),
    content: content.slice(0, 4000),
    created_at: (Number.isFinite(message.created_at) ? message.created_at : Date.now())
  };
};

const normalizePosition = (position) => {
  if (!position || typeof position !== 'object') {
    return null;
  }

  const x = parseFloat(position.x);
  const y = parseFloat(position.y);
  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    return null;
  }

  return { x: x, y: y };
};

const normalizeMemory = (memory) => {
  const messages = (Array.isArray(memory && memory.messages) ? memory.messages : [])
    .map(normalizeMessage)
    .filter((entry) => entry !== null)
    .slice(-MAX_CHAT_MESSAGES);

  return {
    messages: messages,
    position: normalizePosition(memory && memory.position),
    collapsed: !!(memory && memory.collapsed)
  };
};

export const getMapChatMemory = () => {
  if (typeof window === 'undefined' || !window.localStorage) {
    return normalizeMemory({});
  }

  try {
    const raw = window.localStorage.getItem(MAP_CHAT_MEMORY_KEY);
    if (!raw) {
      return normalizeMemory({});
    }

    return normalizeMemory(JSON.parse(raw));
  } catch (error) {
    return normalizeMemory({});
  }
};

export const saveMapChatMemory = (memory) => {
  const nextMemory = normalizeMemory(memory);

  if (typeof window !== 'undefined' && window.localStorage) {
    try {
      window.localStorage.setItem(MAP_CHAT_MEMORY_KEY, JSON.stringify(nextMemory));
    } catch (error) {
      return nextMemory;
    }
  }

  return nextMemory;
};
